/**
 * Executes `valueOrFn` if it's a function, or returns it directly.
 * Useful for handling dynamic configurations that might be values or functions.
 * Credit: https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/theme/src/utils/run-if-fn.ts#L4
 */
export function runIfFn<T, U>(
  valueOrFn: T | ((...fnArgs: U[]) => T),
  ...args: U[]
): T {
  return isFunction(valueOrFn) ? valueOrFn(...args) : valueOrFn;
}

const isFunction = (value: unknown): value is () => unknown =>
  typeof value === 'function';
